import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { interactionsTypeActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class InteractionsType extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newInteractionType, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Interações Tipo'}
          classes={classes}
          newResource={newInteractionType}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'interacoes_tipo'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.interactionsType.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsTypeActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsTypeActions.closeModal())
    },
    newInteractionType: interactionType => {
      dispatch(interactionsTypeActions.newFormInteractionType(interactionType))
    },
    resetState: () => {
      dispatch(interactionsTypeActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(InteractionsType))



// WEBPACK FOOTER //
// ./src/containers/InteractionsType/index.js